module.exports = __webpack_public_path__ + "img/Frame-22.217e9209.svg";